import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Tooltip,
} from "chart.js";

// Register every Chart.js component used by the clinical-study charts a single
// time. Chart.js requires each controller, element, scale, and plugin to be
// registered before a chart that uses it is built; registering here — rather
// than per-component — guarantees the full set is available no matter which
// chart a page renders.
Chart.register(
    BarController,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Tooltip,
);

export { Chart };
export type { TooltipItem } from "chart.js";
